export const QuantitiesRouting = [
  {
    path: "/labor/quantities/list",
    name: "labor--list",
    meta: { title: "劳务工程量" },
    component: () =>
      import(/* webpackChunkName: "project-profile" */ "@/views/labor/quantities/list/index.vue"),
  },
  {
    hidden: true,
    path: "/labor/quantities/create",
    name: "labor-quantities-create",
    meta: { title: "新建劳务工程量" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/labor/quantities/form-create/index.vue"
      ),
  },

  {
    hidden: true,
    path: "/labor/quantities/detail/:id",
    name: "labor-quantities-detail",
    meta: { title: "劳务工程量详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/labor/quantities/form-detail/index.vue"
      ),
  },
];
